export default __webpack_public_path__ + "static/media/port2.97fbef2c.png";